<!--nav standalone component to be added to the app-->
<template>
<div  class="has-navbar-fixed-top">
  <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
  <div class="navbar-brand">
    <a class="navbar-item" href="/">
      <img src="../../assets/logo.png" >
    </a>

    <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" @click="showNav = !showNav" :class="{ 'is-active': showNav }">
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>

  <div id="navbar-fitness" class="navbar-menu" :class="{ 'is-active': showNav }">
    <div class="navbar-end">
     <router-link to="/" class="navbar-item">Home</router-link>
     <router-link to="/register" class="navbar-item">Register</router-link>
     <router-link to="/login" class="navbar-item">Login</router-link>
     <router-link to="/profile" class="navbar-item">Profile</router-link>
    </div>
  </div>
</nav>
</div>
</template>

<script>
export default {
    name: 'Nav',
    components:{

    },
  data() {
    return {
      showNav: false
    };
  },}
</script>
<style lang="scss" scoped>
  nav {
    a {
      font-weight: 300;
      color: #2c3e50;
      padding:10px;
      font-size: 1.1rem;
      font-family: 'Times New Roman', Times, serif;
      text-decoration:none;
      &.router-link-exact-active {
        color: orangered;
      }
    }
  }
 
</style>